// extracted by mini-css-extract-plugin
export default {"filters":"clientslistpage_filters__RW8aB","table":"clientslistpage_table__g0d6X","stretchCol":"clientslistpage_stretchCol__UwgyN"};